import {createSlice} from "@reduxjs/toolkit";
import {DataGridPageState, DEFAULT_SHIFT_FILTER, ShiftFilterFormValues} from "@ots-frontend/ots-ui";
import {setShiftPageFilter, setShiftPageState, setShiftPageStateSort} from "./actions";
import {setShiftPageStateCell, setShiftPageStateWidths} from "../shift-page/actions";

const savedColWidths = localStorage.getItem("shiftPageWidths1")

type State = {
  filter: ShiftFilterFormValues
  state: DataGridPageState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_SHIFT_FILTER,
  state: {
    cell: undefined,
    widths: savedColWidths ? JSON.parse(savedColWidths) : [],
  }
};

const shiftPageSlice = createSlice({
  name: "ui/shift-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setShiftPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setShiftPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      setShiftPageStateCell,
      (state, {payload}) => {
        state.state.cell = payload
      }
    );
    builder.addCase(
      setShiftPageStateWidths,
      (state, {payload}) => {
        state.state.widths = payload
      }
    );
    builder.addCase(
      setShiftPageStateSort,
      (state, {payload}) => {
        state.state.sort = payload
      }
    );
  }
});

export const shiftPageReducer = shiftPageSlice.reducer;
